import axios from 'axios';

export function HTTP(token) {
  if (!token) {
    token = 'Bearer ' + process.env.API_TOCKEN;
  }
  return axios.create({
    baseURL: process.env.API_HOST,
    headers: {
      Authorization: token
    }
  });
}



// WEBPACK FOOTER //
// ./src/core/http/http-token.js